


















import { Vue, Component } from "vue-property-decorator";
import firebase from "firebase";
import auth from "@/store/modules/auth";
import { db } from "@/main";
import { getCloudMessaging } from "@/messaging";

@Component
export default class Home extends Vue {

  async created() {
    const messaging = getCloudMessaging();
    await messaging.initialize();
    
    messaging.onMessage((message) => {
      console.log("Message", message);
      const toastOptions = {
        header: message.notification.title,
        message: message.notification.body,
        showCloseButton: true,
        translucent: true
      };
      this.$ionic.toastController.create(toastOptions).then(toast => toast.present());
      
    });
    /*try {
      console.log(auth.user);
      if (auth.user === null || !messaging) return;
      
      await messaging.requestPermission();
      
      const token = await messaging.getToken();
      debugger;
      console.log('Permission granted ' + token);
      db.collection('users').doc(auth.user.uid).set({notificationTokens: firebase.firestore.FieldValue.arrayUnion(token)});
    } catch(e) {
      console.log('Permission denied', e);
    }*/
  }

  get user() {
    return auth.user;
  }
  get userPicture() {
    return auth.user ? auth.user.photoURL + "?type=large" : "";
  }
}
